import { useTranslation } from 'contexts/Localization'
import { BestRecordText } from './styles'
import { formatLasted } from '../utils'

const BestRecordLabel: React.FC<{ lasted: number }> = ({ lasted }) => {
  const { t } = useTranslation()

  if (lasted <= 0) return null

  return <BestRecordText>{t('Best %time%', { time: formatLasted(lasted, t) })}</BestRecordText>
}

export default BestRecordLabel
